import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONVENIOSEXECUCAODIRETA_PORT}${process.env.VUE_APP_API_PATH}/conveniosexecucaodireta`;
const urlBase = `${api}`;

export default {
    obterTodasReceitasReconhecidasPorDespesas(idCnt) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/receitas/relatoriostodasreceitasreconhecidaspordespesas`);
    },

    obterTodasReceitasReconhecidasPorDespesasRelatorioComFiltro(filtro) {
        return axiosJwt.get(`${urlBase}/${filtro.idCnt}/relatorios/receitas/relatoriostodasreceitasreconhecidaspordespesasrelatoriocomfiltro`, {
            responseType: 'blob',
            params: filtro,
        });
    },

    obterTodasReceitasReconhecidasPorDespesasRelatorio(idCnt) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/receitas/relatoriostodasreceitasreconhecidaspordespesasrelatorio`, {
            responseType: 'blob',
        });
    },
    obterPorFiltroReceitasReconhecidasPorDespesa(filtro) {
        return axiosJwt.get(`${urlBase}/${filtro.idCnt}/relatorios/receitas/relatoriostodasreceitasreconhecidaspordespesascomfiltro`, {
            params: filtro,
        });
    },

    obterRelatorioConsolidado(idCnt) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/despesas/consolidado`, {
            responseType: 'blob',
        });
    },

    obterRelatorioDespesaIndividual(idCnt, convenioDespesaId) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/despesas/individual/${convenioDespesaId}`, {
            responseType: 'blob',
        });
    },
    printPDF(blob) {
        const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };
    },
};
